const insertPopups = async () => {
	// Get the post ID and REST URL from the global variable.
	const { restUrl, postId } = window.emPopups;
	// Fetch the popup HTML from the REST API.
	const request = await fetch(`${restUrl}?post=${postId}`);
	// Parse the JSON response.
	const json = await request.json();
	// Get the HTML from the JSON response.
	const { data: html, success } = json;
	if (success) {
		// Create a container element and insert the HTML.
		const container = document.createElement('div');
		container.classList.add('em-popups-container');
		container.innerHTML = html;
		document.body.appendChild(container);
	}
};

window.addEventListener('load', insertPopups);
